module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-tabs"
  }, [_c('ul', {
    staticClass: "tabs",
    attrs: {
      "id": _vm.id,
      "data-tabs": "",
      "data-deep-link": _vm.deepLink,
      "data-update-history": _vm.deepLink,
      "data-deep-link-smudge": _vm.deepLink
    }
  }, _vm._l((_vm.tabs), function(tab, index) {
    return _c('li', {
      staticClass: "tabs-title",
      class: {
        'is-active': index === _vm.activeIndex
      }
    }, [_c('a', {
      attrs: {
        "href": '#' + _vm.$toDashedString(tab),
        "aria-selected": index === _vm.activeIndex
      }
    }, [_vm._v(_vm._s(tab))])])
  }), 0), _c('div', {
    staticClass: "tabs-content",
    attrs: {
      "data-tabs-content": _vm.id
    }
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-48ed063c!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/foundation/TabHeaders.vue
// module id = 2467
// module chunks = 1